/*
  «Отвязать» в строке дома участка (вынесено из `CourtBuildings.jsx` 23.10.2026).

  🔴 Находка ревизоров 23.10.2026: «Отвязать» отвязывало дом одним нажатием, а
  вместе с домом сервер безвозвратно удаляет скан протокола собрания - файл со
  списком собственников, который загружали и сверяли. У дома со сканом поэтому
  сначала окно, и оно прямо говорит, что скан будет удалён. Дом без скана
  отвязывается, как прежде, сразу: потерять там нечего, кроме самой привязки, а её
  восстанавливает та же кнопка «Привязать».

  Отказ сервера показывается там, где нажали: в окне, если оно открыто, и под
  кнопкой, если окна не было (чек-лист формы, пункт 1).
*/

import { useState } from 'react'

import { Confirm, Notice } from './Common.jsx'

export default function CourtDetachButton({ building, onDetach }) {
  const [asking, setAsking] = useState(false)
  const [busy, setBusy] = useState(false)
  const [failure, setFailure] = useState(null)
  const scan = building.protocol_scan

  async function detach() {
    setBusy(true)
    setFailure(null)
    try {
      await onDetach()
      setAsking(false)
    } catch (error) {
      setFailure(error)
    } finally {
      setBusy(false)
    }
  }

  function close() {
    setAsking(false)
    setFailure(null)
  }

  return (
    <>
      <button
        className="button button--quiet"
        type="button"
        disabled={busy}
        onClick={() => (scan ? setAsking(true) : detach())}
      >
        Отвязать
      </button>
      {asking ? (
        <Confirm
          title="Отвязать дом?"
          action="Отвязать и удалить скан"
          busy={busy}
          error={failure}
          onCancel={close}
          onConfirm={detach}
        >
          Вместе с домом «{building.full_address || building.address}» будет удалён скан
          протокола общего собрания ({scan.filename}). Восстановить его нельзя: после новой
          привязки скан придётся загрузить заново.
        </Confirm>
      ) : (
        <Notice error={failure} />
      )}
    </>
  )
}
